import React from 'react';
import styled from 'styled-components';
import { headingFontFamily } from 'components/shared/DesignSystem/shared/styles';

// #region styled-components
function renderBackgroundColor(isFocused: boolean, isSelected: boolean) {
  if (isFocused) {
    return 'var(--cc_color_button_background_primary)';
  } else if (isSelected) {
    return 'var(--cc_color_background_3)';
  } else {
    return 'var(--cc_color_background_1)';
  }
}
const StyledOption = styled.div<{ isFocused: boolean; isSelected: boolean }>`
  cursor: pointer;
  padding: var(--cc_size_spacing_s) var(--cc_size_spacing_m);
  background-color: ${(props) =>
    renderBackgroundColor(props.isFocused, props.isSelected)};
  display: flex;
  align-items: center;
  gap: var(--cc_size_spacing_m);
`;

const OptionSecondary = styled.div<{ isFocused: boolean }>`
  flex-shrink: 0;
  ${headingFontFamily}
  font-weight: 700;
  font-size: var(--cc_size_text_xxs);
  text-transform: uppercase;
  color: ${(props) =>
    props.isFocused
      ? 'var(--cc_color_button_text_primary)'
      : 'var(--cc_color_text_nonessential)'};
`;

const OptionPrimary = styled.div<{ isFocused: boolean }>`
  flex: 1;
  min-width: 1px;
  font-size: var(--cc_size_text_s);
  color: ${(props) =>
    props.isFocused
      ? 'var(--cc_color_button_text_primary)'
      : 'var(--cc_color_link_secondary)'};
`;
// #endregion

type SelectOptionProps = {
  innerRef: React.RefCallback<HTMLDivElement>;
  innerProps: React.HTMLAttributes<HTMLDivElement>;
  isFocused: boolean;
  isSelected: boolean;
  primaryDescription: string;
  secondaryDescription: string;
};

const SelectOption = ({
  innerRef,
  innerProps,
  isFocused,
  isSelected,
  primaryDescription,
  secondaryDescription,
}: SelectOptionProps) => {
  return (
    <StyledOption
      ref={innerRef}
      {...innerProps}
      isFocused={isFocused}
      isSelected={isSelected}
    >
      <OptionPrimary isFocused={isFocused}>{primaryDescription}</OptionPrimary>
      <OptionSecondary isFocused={isFocused}>
        {secondaryDescription}
      </OptionSecondary>
    </StyledOption>
  );
};

export default SelectOption;
